import { Avatar, Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useRef, useState } from 'react';
import { LanguageService } from '../../../../../../../services/languageService';
import { ArrowIcons } from '../../../../../../components/common/arrowIcons';
import SAflag from '../../../../../../../assets/images/flag-sa.svg';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { IS_SA } from '../../../../../../../config/appConfig';


export default function LanguagePopover() {
	const languageService = new LanguageService();
	const anchorRef = useRef(null);
	const toggledLanguage = languageService.getToggledLanguage();
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const onToggleLanguage = () => {
		languageService.onToggleLanguage();
	};

	return (
		<>
			<Box
				className="md:-mx-1"
				ref={anchorRef}
				onClick={handleOpen}
				sx={{
					cursor: 'pointer',
					padding: 0,
					...(open && {
						bgcolor: (theme) =>
							alpha(
								theme.palette.primary.main,
								theme.palette.action.focusOpacity
							),
					}),
				}}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
					{IS_SA ? <Avatar
						src={SAflag}
						sx={{ width: 20, height: 20 }}></Avatar> : <Avatar
							className="!bg-transparent"
							sx={{ width: 18, height: 18 }}>
						<LanguageOutlinedIcon className="!text-[#ffff] !text-[22px] opacity-95" />
					</Avatar>}
					<Box className="flex items-center" onClick={() => {
						onToggleLanguage();
					}}>
						<Typography
							variant="subtitle2"
							sx={{ color: 'white', marginTop: '2px' }}>
							<span>{toggledLanguage?.name}</span>
						</Typography>
						<ArrowIcons classList={`!text-[18px] !text-white`} isKeyboardArrow />
					</Box>
				</Box>
			</Box>
		</>
	);
}
